export const ButtonSeparator = () => {
  return <div className="border-t border-gray-400" />;
};
